import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { baseurImage, baseurl } from "../../../Baseurl";
import axios from "axios";
import { toast } from "react-toastify";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import axiosInstance from "../../../api/axiosInstance";

export default function EditStaff() {
  const location = useLocation();
  const navigate = useNavigate();
  const staff = location.state?.staff;

  const [formData, setFormData] = useState({
    email: "",
    fullName: "",
    shortName: "",
    prefix: "",
    dateOfBirth: "",
    licenseId: "",
    civilId: "",
    passport: "",
    gender: "",
    specialty: "",
    phoneNumber: "",
    role: "",
    password: "",
  });
  const [files1, setFiles1] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (staff) {
      setFormData({
        email: staff.email || "",
        fullName: staff.fullName || "",
        shortName: staff.shortName || "",
        prefix: staff.prefix || "",
        dateOfBirth: staff.dateOfBirth ? staff.dateOfBirth.split('T')[0] : "",
        licenseId: staff.licenseId || "",
        civilId: staff.civilId || "",
        passport: staff.passport || "",
        gender: staff.gender || "",
        specialty: staff.specialty || "",
        phoneNumber: staff.phoneNumber || "",
        role: staff.role || "",
      });
    }
  }, [staff]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    setFiles1(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formDataToSend = new FormData();

      // Add all form fields
      Object.keys(formData).forEach(key => {
        if (formData[key]) {
          formDataToSend.append(key, formData[key]);
        }
      });

      // Add file if selected
      if (files1) {
        formDataToSend.append("personalPhoto", files1);
      }

      const response = await axiosInstance.put(`updateDoctorDetails/${staff.id}`, formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200) {
        toast.success("Staff updated successfully!");
        navigate("/Admin/ManageStaff");
      }
    } catch (error) {
      console.error("Error updating staff:", error);
      toast.error("Failed to update staff. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Helper function to get staff image URL
  const getStaffImageUrl = (staff) => {
    if (staff.personalPhoto && staff.personalPhoto !== "null" && staff.personalPhoto !== "undefined") {
      return "../assets/images/user/avatar-2.jpg";
    }
    return `${baseurImage}${staff.personalPhoto}`;
  };

  if (!staff) {
    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="col-12">
            <div className="card table-card">
              <div className="tableHeader">
                <h5 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span
                    style={{ cursor: 'pointer', color: '#3f75c7', fontWeight: 'bold', fontSize: '1.5rem' }}
                    onClick={() => navigate(-1)}
                    title="Back"
                  >
                    &larr;
                  </span>
                  Edit Staff
                </h5>
              </div>
              <div className="card-body text-center">
                <p>No staff data available</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pc-container">
      <div className="pc-content">
        <div className="col-12">
          <div className="card table-card">
            <div className="tableHeader">
              <div className="d-flex">
                <ArrowBackIcon style={{ cursor: "pointer" }} onClick={() => navigate(-1)} /> <h5>Edit Staff</h5>
              </div>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit} encType="multipart/form-data" className="row g-3 px-3 py-2 mb-3">

                <div className="col-md-6">
                  <label className="form-label">Prefix</label>
                  <select
                    className="form-control"
                    name="prefix"
                    value={formData.prefix}
                    onChange={handleChange}
                  >
                    <option value="">{formData.prefix}</option>
                    <option value="Dr.">Dr.</option>
                    <option value="Mr.">Mr.</option>
                    <option value="Mrs.">Mrs.</option>
                    <option value="Miss">Miss</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label">First Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    placeholder="First Name"
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Last Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="shortName"
                    value={formData.shortName}
                    onChange={handleChange}
                    placeholder="Last Name"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="staff@gmail.com"
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Gender</label>
                  <select
                    className="form-control"
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label">Role</label>
                  <select
                    className="form-control"
                    name="role"
                    value={formData.role}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    <option value="admin">Admin</option>
                    <option value="receptionist">Receptionist</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label">Date of Birth</label>
                  <input
                    type="date"
                    className="form-control"
                    name="dateOfBirth"
                    value={formData.dateOfBirth}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">License ID</label>
                  <input
                    type="text"
                    className="form-control"
                    name="licenseId"
                    value={formData.licenseId}
                    onChange={handleChange}
                    placeholder="License Number (if applicable)"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Civil ID</label>
                  <input
                    type="text"
                    className="form-control"
                    name="civilId"
                    value={formData.civilId}
                    onChange={handleChange}
                    placeholder="Civil ID"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Passport</label>
                  <input
                    type="text"
                    className="form-control"
                    name="passport"
                    value={formData.passport}
                    onChange={handleChange}
                    placeholder="Passport Number"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Phone Number</label>
                  <input
                    type="text"
                    className="form-control"
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleChange}
                    placeholder="+91 8859932237"
                    required
                  />
                </div>
                {/* <div className="col-md-6">
                  <label className="form-label">Specialty/Department</label>
                  <input
                    type="text"
                    className="form-control"
                    name="specialty"
                    value={formData.specialty}
                    onChange={handleChange}
                    placeholder="Department or Specialty"
                  />
                </div> */}
                <div className="col-md-6">
                  <label className="form-label">Photo</label>
                  <input
                    type="file"
                    name="personalPhoto"
                    className="form-control"
                    onChange={handleFileChange}
                    accept="image/*"
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Password (Leave blank to keep current)</label>
                  <div className="position-relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      placeholder="Enter new password"
                      autoComplete="new-password"
                    />
                    <i
                      className={`ti ${showPassword ? "ti-eye-off" : "ti-eye"}`}
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        fontSize: "18px",
                      }}
                    ></i>
                  </div>
                </div>

                <div className="col-12 mb-3 text-center">
                  <button type="submit" className="bgBtn" disabled={loading}>
                    {loading ? "Updating..." : "Update Staff"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
